import { EventAccordionItemBodyComponentType } from 'src/components/Accordions';
import { FormatOptionEntries } from 'src/modals/EditTableColumns';
import { PurchasesTableColumnId } from 'src/utils/columns/purchases/purchasesColumnUtils.types';
import {
  PurchaseOrderTicketGroup,
  PurchaseViewMode,
} from 'src/WebApiController';

import { TableProps } from '../Table/Table';

export const SHIMMERING_DIV_HEIGHT_SINGLE_PURCHASE = '30px';

export type PurchaseOrderTableDataProps = {
  useVirtuoso?: boolean;
} & Pick<
  EventAccordionItemBodyComponentType<PurchaseOrderTicketGroup>,
  | 'onMount'
  | 'onUnmount'
  | 'initState'
  | 'disablePagination'
  | 'onItemSelectionsChanged'
  | 'entities'
  | 'entityCount'
  | 'getDataFail'
  | 'enableColumnFilters'
>;

export type PurchaseOrderTableProps = PurchaseOrderTableDataProps & {
  groupId: string; // First of month, or event virtualId
  entitiesSummary?: PurchaseOrderTicketGroup | null;
  viewMode?: PurchaseViewMode;
  alwaysShowCheckbox?: boolean;
  showSelectAllOnHeader?: boolean;
  isItemsLoading?: boolean;
  rowSupportsAccordion?: boolean;
  columnVisibilityOverride?: PurchasesTableColumnId[];
  formatOptionOverrides?: FormatOptionEntries;
  withOuterPadding?: boolean;
  disableSelection?: boolean;
  isSideTable?: boolean;
  ignoreMaxCount?: boolean;
} & Pick<
    TableProps<PurchaseOrderTicketGroup | null>,
    'RowComponent' | 'virtuosoItemSize'
  >;
